import type { ChangeOrder, ChangeOrderStatus } from "../types";

const PENDING_STATUSES: ChangeOrderStatus[] = [
  "building",
  "technical_approval",
  "sales_approval",
  "business_approval",
];

export interface PendingSummary {
  count: number;
  revenue: number;
}

// Change requests still on their way to approval, and the revenue they'd add.
// Built from the loaded rows: projects have few change requests, so the list's
// one page is all of them.
export const pendingSummary = (rows: ChangeOrder[]): PendingSummary => {
  const pending = rows.filter(
    (r) => !r.referenceOnly && PENDING_STATUSES.includes(r.status)
  );
  return {
    count: pending.length,
    revenue: pending.reduce((sum, r) => sum + (r.revenue ?? 0), 0),
  };
};
